import { render, staticRenderFns } from "./Game5-10.vue?vue&type=template&id=3f4a3f30&scoped=true&"
import script from "./Game5-10.vue?vue&type=script&lang=js&"
export * from "./Game5-10.vue?vue&type=script&lang=js&"
import style0 from "./Game5-10.vue?vue&type=style&index=0&id=3f4a3f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a3f30",
  null
  
)

export default component.exports